import { Box, Chip } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";
import parse from "html-react-parser";

import { Reference } from "./References.data";

export const getReferencesColumns = (
  onActionClick: (_number: number) => void,
): GridColDef<Reference>[] => [
  {
    field: "reference",
    headerName: "Reference ##",
    width: 120,
  },
  {
    field: "link",
    headerName: "Name and Link",
    flex: 1,
    minWidth: 300,
    sortable: false,
    renderCell: ({ row }) => (
      <Box sx={{ whiteSpace: "normal", lineHeight: 1.5, py: 1 }}>
        {parse(row.link)}
      </Box>
    ),
  },
  {
    field: "actions",
    headerName: "Related Actions and Artifacts",
    width: 250,
    sortable: false,
    renderCell: ({ row }) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 1 }}>
        {row.actions?.map((number) => (
          <Chip
            key={number}
            variant="outlined"
            color="primary"
            size="small"
            sx={{ minWidth: 25, p: 0 }}
            label={number}
            onClick={() => onActionClick(number)}
          />
        ))}
      </Box>
    ),
  },
];
